export default "__VITE_ASSET__DUANK9z$__"